import React, { useContext } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import wwuStyles from "./workwithus.module.css";

function WorkWithUs() {
  const { data } = useContext(LanguageContext);
  const Data = data.workWithUs;

  return (
    <div className="mainWrap">
      <div>
        <h2 className="mainHeading">{Data.title}</h2>
        <p className="subHeading">{Data.subtitle}</p>
      </div>

      <div className={wwuStyles.wwuMainWrap}>
        <p>{Data.pone}</p>

        <p>{Data.ptwo}</p>

        <p>{Data.pthree}</p>
      </div>
      <div className={wwuStyles.wwuButtonWrap}>
        <button>
          {Data.email}
          <img src="/assets/images/careers/send_icon.png" alt="send" />
        </button>
      </div>
    </div>
  );
}

export default WorkWithUs;
